import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ErrorView, BASE_UI_URL, DEFAULT_ANALYTICS_PAGE_VIEW } from '@americanexpress/arcade-core';
import { useIntl } from 'react-intl';
import { useUpdateView } from '@americanexpress/data-manager-utils';
import { useReactlytics } from '@americanexpress/reactlytics';

const ErrorPage = ({ router }) => {
  const intl = useIntl();
  const updateView = useUpdateView();
  const { track } = useReactlytics();
  useEffect(() => {
    updateView({
      viewId: `${DEFAULT_ANALYTICS_PAGE_VIEW}|page-not-found`,
    });
  }, []);

  const handleBack = () => {
    track({ event: { identifier: 'axp-passport-page-not-found', element: 'back-btn', type: 'click' } });
    router.goBack();
  };

  const handleButtonClick = () => {
    track({ event: { identifier: 'axp-passport-page-not-found', element: 'return-btn', type: 'click' } });
    router.replace(BASE_UI_URL);
  };

  return (
    <ErrorView
      isNative={true}
      isFullScreen={true}
      backgroundImageUrl="https://icm.aexp-static.com/Internet/IMDC/arcade/Images/ErrorBackground.png"
      description={intl.formatMessage({
        id: 'page.not.found.description',
        defaultMessage: 'We were unable to find a page matching your request.',
      })}
      buttonText={intl.formatMessage({
        id: 'page.not.found.button.text',
        defaultMessage: 'Return to Amex Passport',
      })}
      onBackBtnClick={handleBack}
      onButtonClick={handleButtonClick}
    />
  );
};

ErrorPage.propTypes = {
  router: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }),
};

export default ErrorPage;
